module.exports = __webpack_public_path__ + "img/loginbac.150721a6.png";